// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"Register_registerForm__3mUSh","links":"Register_links__1IgG7"};